var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-2 py-1 text-gray-700"},[_vm._v("Due: "+_vm._s(_vm.dueAt))])
}
var staticRenderFns = []

export { render, staticRenderFns }